import { render, staticRenderFns } from "./questionsDetail3.vue?vue&type=template&id=00f71cf9&"
import script from "./questionsDetail3.vue?vue&type=script&lang=js&"
export * from "./questionsDetail3.vue?vue&type=script&lang=js&"
import style0 from "./questionsDetail3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports